
 <!-- <div class="content-wrapper pt-2"> -->
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Draw a Cheque</div> 
      <form  [formGroup] ="form"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="row">

        <div class="form-group">
          <input  name="id" readonly formControlName="id"  class="form-control"    type="hidden">
          </div>

        <div class="col-md-4">
            <div class="form-group">
            <label for="chequeRefNo" class="col-form-label">Cheque Ref.No</label>  
            <div class="input-group">
                <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="chequeRefNo" placeholder="Cheque Ref.No"  class="form-control field-bg-color" [class.is-invalid]="formErrors.chequeRefNo" (blur)="logValidationErrors()"   type="text">
                </div>
                <span class="text-danger" *ngIf="formErrors.chequeRefNo"><small>{{formErrors.chequeRefNo}}</small> </span>   
            </div>
          </div>

          <div class="col-md-4">        
            <div class="form-group">
            <label for="payeeName" class="col-form-label ">Payee Name</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  [ngClass]="{'dark-input-field' : isDark }"  [matAutocomplete]="autoCustomer" formControlName="payeeName" placeholder="Payee Name"  class="form-control field-bg-color" [class.is-invalid]="formErrors.payeeName" (blur)="logValidationErrors()"  type="text">
            <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.SupName">
                  {{option.SupName}}
                </mat-option>
              </mat-autocomplete> 
        </div>
          <span class="text-danger" *ngIf="formErrors.payeeName"><small>{{formErrors.payeeName}}</small> </span>   
           </div>      
        </div>

        <div class="col-md-4">        
            <div class="form-group">
            <label for="chequeNo" class="col-form-label ">Cheque No</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="chequeNo" placeholder="Cheque No"  class="form-control field-bg-color" [class.is-invalid]="formErrors.chequeNo" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.chequeNo"><small>{{formErrors.chequeNo}}</small> </span>   
           </div>      
        </div>


    </div>

    
    <div class="row">   

        <div class="col-md-4">        
            <div class="form-group">
            <label for="bank" class="col-form-label ">Bank</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <select [ngClass]="{'dark-input-field' : isDark }" formControlName="bank" class="form-control field-bg-color"   [class.is-invalid]="formErrors.bank" (blur)="logValidationErrors()">        
              <option [ngValue]="null">-Select-</option>
              <option *ngFor="let item of bankList" [value]="item.value">
                {{item.value}}
              </option>
          </select>          </div>
          <span class="text-danger" *ngIf="formErrors.bank"><small>{{formErrors.bank}}</small> </span>   
           </div>      
        </div>

        <div class="col-md-4">        
            <div class="form-group">
            <label for="branch" class="col-form-label ">Branch</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="branch" placeholder="Branch"  class="form-control field-bg-color"  type="text">
          </div>
           </div>      
        </div>

        <div class="col-md-4">        
            <div class="form-group">
            <label for="amount" class="col-form-label ">Amount</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="amount" placeholder="Amount"  class="form-control field-bg-color" [class.is-invalid]="formErrors.amount" (blur)="logValidationErrors()"  type="text">
          </div>
          <span class="text-danger" *ngIf="formErrors.amount"><small>{{formErrors.amount}}</small> </span>   
           </div>      
        </div>

        </div>

        <div class="row">   
        
        <div class="col-md-4">
          <div class="form-group">
            <label for="chequeDate" class="col-form-label ">Cheque Date</label>  
            <div class="input-group">
                <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker  placement="top" [bsConfig]="datepickerConfig" formControlName="chequeDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.chequeDate" (blur)="logValidationErrors()" placeholder="Cheque Date">
            </div>
            <span class="text-danger" *ngIf="formErrors.chequeDate"><small>{{formErrors.chequeDate}}</small> </span>   
            </div>
         </div>

         
        <div class="col-md-4">        
            <div class="form-group">
            <label for="remarks" class="col-form-label ">Remarks</label>  
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
            </div>
            <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="remarks" placeholder="Remarks"  class="form-control field-bg-color"   type="text">
          </div>
           </div>      
        </div>

          
        <div class="col-md-4">
            <div class="form-group">
                <label for="status" class="col-form-label ">Status</label>  
                <div class="input-group">
                  <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                </div>
                <select [ngClass]="{'dark-input-field' : isDark }" formControlName="status" class="form-control field-bg-color"   [class.is-invalid]="formErrors.status" (blur)="logValidationErrors()">        
                    <option [ngValue]="null">-Select-</option>
                    <option *ngFor="let item of statusList" [value]="item.value">
                      {{item.value}}
                    </option>
                </select>
                  </div>
                  <span class="text-danger" *ngIf="formErrors.status"><small>{{formErrors.status}}</small> </span>   
            </div>
            </div>  

        </div>


      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-primary ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../draw-cheque-list"><i class="fa fa-table p-1"></i>Cheque List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
    <!-- </div> -->


    <!-- Form Values : {{ addCustomerForm.value | json }} -->
  
